import RichTextInput from "../../../ui/RichTextInput"
import { Controller } from "react-hook-form"
import usePolicyAndRulesForm from "./usePolicyAndRulesForm"
import ProcessingState from "~/components/ui/Admin/ProcessingState"
import SaveButtons from "../SaveButtons"

const PolicyAndRulesForm = () => {
  const { reactHookForm, isLoadingData, onSubmit, handleSetDefaultValues, isPendingSaveInvoices, loadedDone } =
    usePolicyAndRulesForm()

  if (isLoadingData) return <ProcessingState loadingMessages={[]} successMessage={""} />

  return (
    //TODO: I had to add an hack to make the richtext reactive, for some reason internally he is not
    // changing when the props change after initial mount, the component itself should be revised
    <form key={JSON.stringify(loadedDone)} onSubmit={reactHookForm.handleSubmit(onSubmit)}>
      <SaveButtons
        isDirty={reactHookForm.formState?.isDirty}
        errors={reactHookForm.formState?.errors}
        handleCancel={handleSetDefaultValues}
        isLoading={isPendingSaveInvoices}
      />
      <div className="pb-20">
        <div className="my-6 space-y-2">
          <div className="text-xl font-semibold text-gray-900">Policy & Rules</div>
          <div className="font-medium text-gray-500">Shows up in booking confirmations and emails.</div>
        </div>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block font-medium text-md text-gray-900">Checkin policy</label>
            <Controller
              name="checkin_policy"
              control={reactHookForm.control}
              render={({ field }) => (
                <RichTextInput value={field.value} setValue={field.onChange} style={{ marginTop: 3.5 }} hyperlink />
              )}
            />
          </div>
          <div>
            <label className="block font-medium text-md text-gray-900">Cancellation policy</label>
            <Controller
              name="refund_policy"
              control={reactHookForm.control}
              render={({ field }) => (
                <RichTextInput value={field.value} setValue={field.onChange} style={{ marginTop: 3.5 }} hyperlink />
              )}
            />
          </div>
          <div>
            <label className="block font-medium text-md mb-1 text-gray-900">Rules</label>
            <Controller
              name="rules"
              control={reactHookForm.control}
              rules={{ required: "Content is required" }}
              render={({ field }) => (
                <RichTextInput value={field.value} setValue={field.onChange} style={{ marginTop: 3.5 }} hyperlink />
              )}
            />
          </div>
        </div>
      </div>
    </form>
  )
}

export default PolicyAndRulesForm
